import type { FC, InputHTMLAttributes } from 'react'
import { classNames } from '@g4g/utils/src/react/class-names'

const TextInputField: FC<
  InputHTMLAttributes<HTMLInputElement> & { icon?: JSX.Element; placeholder?: string }
> = ({ icon, placeholder, ...inputProps }) => {
  return (
    <div className="relative flex w-full h-10">
      {icon && <div className="absolute flex w-5 h-5 top-2.5 left-2 text-white/50">{icon}</div>}
      <input
        {...inputProps}
        className={classNames(
          inputProps.className,
          'w-full ring-1 ring-gray-600 text-white',
          'focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500',
          'rounded-lg',
          'placeholder:text-white/50 bg-[#212733]',
          icon ? 'px-10' : 'px-2'
        )}
        type="text"
        placeholder={placeholder ?? ''}
      />
    </div>
  )
}

export default TextInputField
